import { API_URL } from "../../shared/constants";
import { emptySplitApi } from "../emptySplit-api";

export const vendorApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    vendorList: builder.query<any, any>({
      query: (data: any) => {
        return {
          url: `/${API_URL.VENDORS}/list`,
          method: "post",
          body: data,
        };
      },
    }),
    vendorGet: builder.query({
      query: (id) => ({ url: `/${API_URL.VENDORS}/get/${id}`, method: "post" }),
    }),
    vendorImport: builder.mutation<any, any>({
      query: (data: any) => {
        return {
          url: `/${API_URL.VENDORS}/import`,
          method: "post",
          body: data,
        };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useVendorListQuery,
  useVendorGetQuery,
  useVendorImportMutation,
} = vendorApi;
